export default "__VITE_ASSET__0079f7c2__"